// export const BASE_URL = "http://192.168.29.143";
// export const BASE_PORT = "5000";
// export const USER_API_PREFIX = "api/v2";
// export const ADMIN_API_PREFIX = "api/admin";
// export const MAP_API_URL = `${BASE_URL}:${BASE_PORT}/api/map`;

export const BASE_URL = "https://api.taxica.in";
// export const BASE_PORT = "80";
export const USER_API_PREFIX = "v2";
export const ADMIN_API_PREFIX = "admin";
export const MAP_API_URL = `${BASE_URL}/map`;

export const ACC_STATUS = [
  { id: 1, name: "Active", slug: "active" },
  { id: 0, name: "In-Active", slug: "inactive" },
];

export const PRO_STATUS = [
  {
    id: 1,
    name: "Approve",
    slug: "approve",
  },
  {
    id: 0,
    name: "Un-Approve",
    slug: "unapprove",
  },
];

export const RELATION_DATA = [
  {
    id: 1,
    name: "Father",
  },
  {
    id: 2,
    name: "Mother",
  },
  {
    id: 3,
    name: "Son",
  },
  {
    id: 4,
    name: "Daughter",
  },
  {
    id: 5,
    name: "Husband",
  },
  {
    id: 6,
    name: "Wife",
  },
  {
    id: 7,
    name: "Guardian",
  },
  {
    id: 8,
    name: "Company Owner",
  },
];
